import { Color } from '@/GlobalStyles';

export default {
  larmes: [
    {
      value: 'bon',
      label: 'Bon',
      activeColor: Color.LevelGood,
      inactiveColor: Color.LevelGood,
    },
    {
      value: 'moyen',
      label: 'Moyen',
      activeColor: Color.LevelMid,
      inactiveColor: Color.LevelMid,
    },
    {
      value: 'mauvais',
      label: 'Mauvais',
      activeColor: Color.LevelBad,
      inactiveColor: Color.LevelBad,
    },
    {
      value: 'n/a',
      label: 'N/A',
      activeColor: Color.LevelNA,
      inactiveColor: Color.LevelNA,
    },
  ],
  aberrationOrdreEleve: [
    {
      value: '<0.3µm',
      label: '<0.3µm',
      activeColor: Color.LevelGood,
      inactiveColor: Color.LevelGood,
    },
    {
      value: '<0.5µm',
      label: '<0.5µm',
      activeColor: Color.LevelMid,
      inactiveColor: Color.LevelMid,
    },
    {
      value: '>0.5µm',
      label: '>0.5µm',
      activeColor: Color.LevelBad,
      inactiveColor: Color.LevelBad,
    },
    {
      value: 'n/a',
      label: 'N/A',
      activeColor: Color.LevelNA,
      inactiveColor: Color.LevelNA,
    },
  ],
  aberrationSpherique: [
    {
      value: 'positive',
      label: 'Positive',
      activeColor: Color.LevelGood,
      inactiveColor: Color.LevelGood,
    },
    {
      value: 'nulle',
      label: 'Nulle',
      activeColor: Color.LevelMid,
      inactiveColor: Color.LevelMid,
    },
    {
      value: 'negative',
      label: 'Négative',
      activeColor: Color.LevelBad,
      inactiveColor: Color.LevelBad,
    },
    {
      value: 'n/a',
      label: 'N/A',
      activeColor: Color.LevelNA,
      inactiveColor: Color.LevelNA,
    },
  ],
  endothelium: [
    {
      value: 'bon',
      label: 'Bon',
      activeColor: Color.LevelGood,
      inactiveColor: Color.LevelGood,
    },
    {
      value: 'moyen',
      label: 'Moyen',
      activeColor: Color.LevelMid,
      inactiveColor: Color.LevelMid,
    },
    {
      value: 'severe',
      label: 'Sévère',
      activeColor: Color.LevelBad,
      inactiveColor: Color.LevelBad,
    },
    {
      value: 'n/a',
      label: 'N/A',
      activeColor: Color.LevelNA,
      inactiveColor: Color.LevelNA,
    },
  ],
  diametrePupillaire: [
    {
      value: '<2mm',
      label: '<2mm',
      activeColor: Color.LevelBad,
      inactiveColor: Color.LevelBad,
    },
    {
      value: 'entre 2mm et 2.5mm',
      label: 'entre 2mm et 2.5mm',
      activeColor: Color.LevelMid,
      inactiveColor: Color.LevelMid,
    },
    {
      value: '>2.5mm',
      label: '>2.5mm',
      activeColor: Color.LevelGood,
      inactiveColor: Color.LevelGood,
    },
    {
      value: 'n/a',
      label: 'N/A',
      activeColor: Color.LevelNA,
      inactiveColor: Color.LevelNA,
    },
  ],
  retineNerfOptique: [
    {
      value: 'bon',
      label: 'Bon',
      activeColor: Color.LevelGood,
      inactiveColor: Color.LevelGood,
    },
    {
      value: 'moyen',
      label: 'Moyen',
      activeColor: Color.LevelMid,
      inactiveColor: Color.LevelMid,
    },
    {
      value: 'severe',
      label: 'Sévère',
      activeColor: Color.LevelBad,
      inactiveColor: Color.LevelBad,
    },
    {
      value: 'n/a',
      label: 'N/A',
      activeColor: Color.LevelNA,
      inactiveColor: Color.LevelNA,
    },
  ],
  longueurAxiale: [
    {
      value: '<22',
      label: '<22',
      activeColor: Color.LevelGood,
      inactiveColor: Color.LevelGood,
    },
    {
      value: '22<AL<26',
      label: '22<AL<26',
      activeColor: Color.LevelMid,
      inactiveColor: Color.LevelMid,
    },
    {
      value: '>26',
      label: '>26',
      activeColor: Color.LevelBad,
      inactiveColor: Color.LevelBad,
    },
    {
      value: 'n/a',
      label: 'N/A',
      activeColor: Color.LevelNA,
      inactiveColor: Color.LevelNA,
    },
  ],
  ouiNonInput: [
    {
      value: true,
      label: 'Oui',
      activeColor: Color.LevelGood,
      inactiveColor: Color.LevelGood,
    },
    {
      value: false,
      label: 'Non',
      activeColor: Color.LevelBad,
      inactiveColor: Color.LevelBad,
    },
  ],
  bump: [
    {
      value: 'bon',
      label: 'Bon',
      activeColor: Color.LevelGood,
      inactiveColor: Color.LevelGood,
    },
    {
      value: 'mauvais',
      label: 'Mauvais',
      activeColor: Color.LevelMid,
      inactiveColor: Color.LevelMid,
    },
    {
      value: 'n/a',
      label: 'N/A',
      activeColor: Color.LevelNA,
      inactiveColor: Color.LevelNA,
    },
  ],
};
